import { Component, Input, ChangeDetectionStrategy } from "@angular/core";

import { PersistenceService } from "../store/model/persistence.service";
import { Division } from "../services/consultation.service";
import { DemandValidity } from "../store/validity/state";

@Component({
    selector: "zbd-demand",
    exportAs: "demand",
    templateUrl: "demand.component.html",
    styles: [
        `
            .product-version {
                font-size: 14px;
            }
        `,
    ],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DemandComponent {
    @Input() persistence: PersistenceService;
    @Input() division: Division;
    @Input() validity: DemandValidity;
}
